import React, {FC} from 'react';

import {CircleCheck, CircleXmark} from '@gravity-ui/icons';
import {Card} from '@gravity-ui/uikit';
import i18n from 'ui/i18n';

import VisuallyHidden from '../VisuallyHidden';

import {cnAnswerOption} from './AnswerOption.constants';
import {AnswerOptionProps} from './AnswerOption.types';
import {getContent} from './AnswerOption.utils';

import './AnswerOption.scss';

const AnswerOption: FC<AnswerOptionProps> = ({type, text, correct, selected, widget}) => {
    const content = getContent(text, type, widget, selected);

    return (
        <Card className={cnAnswerOption()} size="m">
            {content}
            {correct ? (
                <>
                    <CircleCheck
                        className={cnAnswerOption('Icon', {correct})}
                        aria-hidden="true"
                        focusable="false"
                    />
                    <VisuallyHidden>{i18n('success-page', 'sr-answer-correct')}</VisuallyHidden>
                </>
            ) : (
                <>
                    <CircleXmark
                        className={cnAnswerOption('Icon')}
                        aria-hidden="true"
                        focusable="false"
                    />
                    <VisuallyHidden>{i18n('success-page', 'sr-answer-incorrect')}</VisuallyHidden>
                </>
            )}
        </Card>
    );
};
export default AnswerOption;
